import apiClient from './api/apiClient.js';

/**
 * Wallet Purchase Service
 * Handles API calls for wallet-mode purchases (no merchant, user buys into own wallet)
 */
const walletPurchaseService = {
    /**
     * Initiate a wallet purchase — creates record + gets provider widget URL
     * @param {Object} params
     * @param {string} params.walletAddress - User's wallet address
     * @param {string} params.provider - Provider name (transak, banxa)
     * @param {number} params.fiatAmount - Amount in fiat
     * @param {string} params.fiatCurrency - Fiat currency code
     * @param {string} params.cryptoCurrency - Crypto currency code
     * @param {string} params.network - Blockchain network
     * @param {string} [params.paymentMethod] - Payment method
     * @param {string} [params.clientId] - Client tracking ID
     * @returns {Promise<{purchaseId: string, widgetUrl: string, expiresAt: string}>}
     */
    async initiatePurchase(params) {
        return apiClient.post('/api/v1/wallet/purchase', params);
    },

    /**
     * Get purchase status by ID
     * @param {string} purchaseId
     * @returns {Promise<Object>} Purchase details with status
     */
    async getPurchaseStatus(purchaseId) {
        return apiClient.get(`/api/v1/wallet/purchase/${purchaseId}`);
    },

    /**
     * Cancel a purchase (only if INITIATED)
     * @param {string} purchaseId
     * @returns {Promise<{success: boolean}>}
     */
    async cancelPurchase(purchaseId) {
        return apiClient.post(`/api/v1/wallet/purchase/${purchaseId}/cancel`);
    },

    /**
     * Get purchase history for a wallet address
     * @param {string} walletAddress
     * @param {number} [limit=20]
     * @param {number} [offset=0]
     * @returns {Promise<Array>} List of purchases
     */
    async getPurchaseHistory(walletAddress, limit = 20, offset = 0) {
        return apiClient.get('/api/v1/wallet/purchases', {
            params: { walletAddress, limit, offset },
        });
    },

    /**
     * Get status history for a purchase
     * @param {string} purchaseId
     * @returns {Promise<Array>} Status change history
     */
    async getStatusHistory(purchaseId) {
        return apiClient.get(`/api/v1/wallet/purchase/${purchaseId}/history`);
    },
};

export default walletPurchaseService;
